import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { VariablePlanilla } from '../types/variable';

interface VariableStore {
  variables: VariablePlanilla[];
  loading: boolean;
  error: string | null;
  historial: VariablePlanilla[];
  historialCodigo: string | null;

  setVariables: (variables: VariablePlanilla[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  updateVariable: (updated: VariablePlanilla) => void;
  addVariable: (variable: VariablePlanilla) => void;
  removeVariable: (id: number) => void;
  setHistorial: (historial: VariablePlanilla[]) => void;
  setHistorialCodigo: (codigo: string | null) => void;
}

export const useVariableStore = create<VariableStore>()(
  devtools(
    (set) => ({
      variables: [],
      loading: false,
      error: null,
      historial: [],
      historialCodigo: null,

      setVariables: (variables) => set({ variables }),
      setLoading: (loading) => set({ loading }),
      setError: (error) => set({ error }),
      updateVariable: (updated) =>
        set((state) => ({
          variables: state.variables.map((v) =>
            v.idVariable === updated.idVariable ? updated : v
          ),
        })),
      addVariable: (variable) =>
        set((state) => ({ variables: [...state.variables, variable] })),
      removeVariable: (id) =>
        set((state) => ({
          variables: state.variables.filter((v) => v.idVariable !== id),
        })),
      setHistorial: (historial) => set({ historial }),
      setHistorialCodigo: (codigo) => set({ historialCodigo: codigo }),
    }),
    { name: 'VariableStore' }
  )
);
